import ProfileExportConfigBuilder from "./exports/ProfileExportConfigBuilder";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";

const ProfileExport = () => {
  const { lensId, configId } = useParamNumbers(["lensId", "configId"]);

  if (!lensId) return <></>;

  return <ProfileExportConfigBuilder lensId={lensId} configId={configId} />;
};

export default ProfileExport;
